import { useEffect } from 'react'
import { useNavigate, useLocation } from '@tanstack/react-router'
import { useAuth } from '@clerk/clerk-react'
import { LAST_LOCATION } from '@/config/settings'
import { storage } from '@/helpers'

export const getRedirectToLastUrl = (): string => {
  let lastUrl: string | undefined
  try {
    lastUrl = storage.getItem(LAST_LOCATION) as string | undefined
  } catch (_err) {
    // nothing here
  }
  return lastUrl || '/shardlibrary'
}

// Redirects authenticated users to their last visited URL (or /shardlibrary).
// Used on the index route and SSO callback/token routes.
export const useRedirectToLastUrl = (): void => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isLoaded, isSignedIn } = useAuth()

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      const lastUrl = getRedirectToLastUrl()
      if (location.pathname !== lastUrl) {
        navigate({ to: lastUrl, replace: true })
      }
    }
  }, [isLoaded, isSignedIn])
}

// Saves shardlibrary URLs to localStorage so useRedirectToLastUrl can restore them.
// Called once in AppShell (in __root.tsx) so it's active for all routes.
export const useSaveLastUrl = (): void => {
  const location = useLocation()

  useEffect(() => {
    const url = location.pathname + (location as any).searchStr
    if (url.startsWith('/shardlibrary')) {
      storage.setItem(LAST_LOCATION, url)
    }
  }, [location.pathname, (location as any).searchStr])
}
